var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"none"}},[_c('path',{attrs:{"id":_vm.name,"d":_vm.getSVG,"fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }